import { Toast } from 'vant'
import { queryResetPassWordGetCode, setStudentResetPassWord } from '@/api'
export default {
  components: {},
  props: [],
  name: 'resetPassword-page',
  data () {
    return {
      user: {
        code: null,
        phone: null,
        newPassword: null,
        isChina: true
      },
      newPassword: null,
      timeNum: null,
      showEyes: false,
      showEyes1: false,
      xphone: null,
      actions: [{ name: '国内', val: true }, { name: '国外', val: false }],
      show: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    this.user.phone = this.$route.query.phone
    this.xphone = this.$route.query.xphone
  },
  mounted () {},
  destroyed () {},
  methods: {
    // 获取验证码
    onSelect (item) {
      this.show = false
      this.user.isChina = item.val
    },
    async inputVerificationCode () {
      if (!this.$route.query.phone) {
        Toast({ message: '请输入手机号', type: 'fail' })
        return
      }
      const { error } = await queryResetPassWordGetCode({ phone: this.$route.query.phone, isChina: this.user.isChina })
      if (error.returnCode === 0) {
        this.timeNum = 60
        const set = setInterval(() => {
          this.timeNum = --this.timeNum
        }, 1000)
        setTimeout(() => {
          this.timeNum = null
          clearInterval(set)
        }, 60000)
      }
    },
    async sureClick () {
      if (!this.user.code) {
        Toast({ message: '验证码不能为空', type: 'fail' })
        return
      }
      if (!this.user.newPassword) {
        Toast({ message: '密码不能为空', type: 'fail' })
        return
      }
      if (this.newPassword !== this.user.newPassword) {
        Toast({ message: '密码输入不一致', type: 'fail' })
        return
      }
      await setStudentResetPassWord(this.user)
      Toast({ message: '修改成功', type: 'success' })
      this.$router.push('/login')
    }
  }
}
